import { createSelector } from 'reselect'

import { selectCockpitAttentionCockpitMode } from './selectCockpitAttentionDrill'
import { selectCockpitRtm } from './selectCockpitRtm'

/** A distributor completes and signs all its offerings as one JBP plan, so the manager cockpit's
 *  distributors view counts partners where it counts plans. */
export const selectCockpitCountsPlansByPartner = createSelector(
  [selectCockpitAttentionCockpitMode, selectCockpitRtm],
  (cockpitMode, selectedRtm) => cockpitMode === 'multiple-partner' && selectedRtm === 'distributors'
)
